var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
import { hexToRgba } from '../helpers';
import { notificationExit } from './keyframes';
var regularVariantMap = {
    info: {
        backgroundColor: hexToRgba(tokens.colors.blue, 0.15),
        borderColor: hexToRgba(tokens.colors.navy, 0.2),
    },
    success: {
        backgroundColor: hexToRgba(tokens.colors.green, 0.2),
        borderColor: hexToRgba(tokens.colors.green, 0.8),
    },
    warning: {
        backgroundColor: hexToRgba(tokens.colors.orangeLight, 0.25),
        borderColor: hexToRgba(tokens.colors.orangeLight, 0.8),
    },
    error: {
        backgroundColor: hexToRgba(tokens.colors.red, 0.15),
        borderColor: hexToRgba(tokens.colors.red, tokens.opacity.high),
    },
    upgrade: {
        backgroundColor: hexToRgba(tokens.colors.purple, 0.15),
        borderColor: hexToRgba(tokens.colors.purple, tokens.opacity.high),
    },
};
var invertedVariantMap = {
    info: {
        backgroundColor: hexToRgba(tokens.colors.blue, 0.25),
        borderColor: hexToRgba(tokens.colors.blue, 0.8),
    },
    success: {
        backgroundColor: hexToRgba(tokens.colors.green, 0.25),
        borderColor: hexToRgba(tokens.colors.green, tokens.opacity.high),
    },
    warning: __assign({}, regularVariantMap.warning),
    error: __assign(__assign({}, regularVariantMap.error), { backgroundColor: hexToRgba(tokens.colors.red, 0.25) }),
    upgrade: {
        backgroundColor: hexToRgba(tokens.colors.purpleLight, 0.25),
        borderColor: hexToRgba(tokens.colors.purpleLight, 0.8),
    },
};
export function notificationStyle(_a) {
    var variant = _a.variant, isBannerMode = _a.isBannerMode, inverted = _a.inverted, isVisible = _a.isVisible;
    var variantMap = inverted ? invertedVariantMap : regularVariantMap;
    var fillBackgroundColor = inverted
        ? tokens.colors.navy
        : tokens.colors.white;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    // A little trick to mix multiple colors with different opacity\n    background: linear-gradient(\n        ", ",\n        ", "\n      ),\n      linear-gradient(", ", ", ");\n    border: ", " solid ", ";\n    width: 100%;\n    // Animation\n    opacity: 1;\n\n    // Overrides for styling the notification card as a banner\n    ", "\n\n    ", "\n  "], ["\n    // A little trick to mix multiple colors with different opacity\n    background: linear-gradient(\n        ", ",\n        ", "\n      ),\n      linear-gradient(", ", ", ");\n    border: ", " solid ", ";\n    width: 100%;\n    // Animation\n    opacity: 1;\n\n    // Overrides for styling the notification card as a banner\n    ", "\n\n    ", "\n  "])), variantMap[variant].backgroundColor, variantMap[variant].backgroundColor, fillBackgroundColor, fillBackgroundColor, tokens.borderWidth.thin, variantMap[variant].borderColor, isBannerMode && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      flex-grow: 0;\n      justify-content: center;\n      border-width: 0 0 ", ";\n      border-radius: 0;\n    "], ["\n      flex-grow: 0;\n      justify-content: center;\n      border-width: 0 0 ", ";\n      border-radius: 0;\n    "])), tokens.borderWidth.thin), !isVisible && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      animation: ", " 300ms ease-out forwards;\n    "], ["\n      animation: ", " 300ms ease-out forwards;\n    "])), notificationExit()));
}
export function contentStyle(_a) {
    var layout = _a.layout, isBannerMode = _a.isBannerMode;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: ", ";\n    flex-grow: 1;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: ", ";\n    flex-grow: 1;\n\n    ", "\n  "])), layout === 'horizontal' ? 'row' : 'column', isBannerMode && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      max-width: 1200px;\n    "], ["\n      max-width: 1200px;\n    "]))));
}
export function actionStyle(_a) {
    var layout = _a.layout, isUpgrade = _a.isUpgrade;
    function calculateLeftMargin() {
        if (layout === 'horizontal') {
            return tokens.spacing.small;
        }
        if (isUpgrade) {
            return 0;
        }
        return "-".concat(tokens.spacing.small);
    }
    function calculateTopMargin() {
        if (layout === 'horizontal') {
            return 0;
        }
        if (isUpgrade) {
            return tokens.spacing.small;
        }
        return tokens.spacing.xsmall;
    }
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-left: ", ";\n    margin-top: ", ";\n    flex-shrink: 0;\n  "], ["\n    margin-left: ", ";\n    margin-top: ", ";\n    flex-shrink: 0;\n  "])), calculateLeftMargin(), calculateTopMargin());
}
export function textContentStyle(_a) {
    var layout = _a.layout;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n    flex-grow: 1;\n  "], ["\n    ", "\n    flex-grow: 1;\n  "])), layout === 'horizontal' && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      display: flex;\n      flex-wrap: wrap;\n    "], ["\n      display: flex;\n      flex-wrap: wrap;\n    "]))));
}
export function titleStyle() {
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin: 0;\n    margin-right: ", ";\n    padding: 4px 0;\n    line-height: ", ";\n  "], ["\n    margin: 0;\n    margin-right: ", ";\n    padding: 4px 0;\n    line-height: ", ";\n  "])), tokens.spacing.small, tokens.lineHeights.relaxed);
}
export function descriptionStyle() {
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin: 0;\n    padding: 4px 0;\n  "], ["\n    margin: 0;\n    padding: 4px 0;\n  "])));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
